import { render, staticRenderFns } from "./bookinged.vue?vue&type=template&id=d3247f8a&scoped=true"
import script from "./bookinged.vue?vue&type=script&lang=js"
export * from "./bookinged.vue?vue&type=script&lang=js"
import style0 from "./bookinged.vue?vue&type=style&index=0&id=d3247f8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3247f8a",
  null
  
)

export default component.exports